import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationsDialogComponent } from '../notifications-dialog/notifications-dialog.component';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
    selector: 'las-notifications-toggle',
    templateUrl: './notifications-toggle.component.html',
    styleUrls: ['./notifications-toggle.component.scss'],
    standalone: false,
})
export class NotificationsToggleComponent implements OnInit {
    hasUnreadNotifications = false;

    constructor(
        private dialog: MatDialog,
        private notificationService: NotificationService,
    ) {}

    ngOnInit(): void {
        // Check for unread notifications on initialization
        this.checkForUnreadNotifications();
    }

    checkForUnreadNotifications(reset = false): void {
        this.notificationService
            .getUnreadNotifications(reset)
            .subscribe(
                (resp) =>
                    (this.hasUnreadNotifications =
                        resp?.notifications.length > 0),
            );
    }

    getHasUnreadNotifications(): boolean {
        // Logic to check for unread notifications
        return this.hasUnreadNotifications;
    }

    /**
     * Opens the notifications dialog.
     */
    openNotificationsDialog(): void {
        const dialogRef = this.dialog.open(NotificationsDialogComponent, {
            width: '1000px',
            height: '1000px',
            maxHeight: '90vh',
            maxWidth: '90vw',
            panelClass: 'notifications-dialog-panel',
            data: {
                defaultToAll: !this.hasUnreadNotifications,
            },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.checkForUnreadNotifications(true);
        });
    }
}
